import { render, staticRenderFns } from "./RelacaoEntreFiliaisDialog.vue?vue&type=template&id=6603986d"
import script from "./RelacaoEntreFiliaisDialog.vue?vue&type=script&lang=js"
export * from "./RelacaoEntreFiliaisDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports